/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldstudenthint3Inputs */

const en_ticketsfieldstudenthint3 = /** @type {(inputs: Ticketsfieldstudenthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The door checks a student ID.`)
};

const de_ticketsfieldstudenthint3 = /** @type {(inputs: Ticketsfieldstudenthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Einlass wird der Studierendenausweis geprüft.`)
};

/**
* | output |
* | --- |
* | "The door checks a student ID." |
*
* @param {Ticketsfieldstudenthint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldstudenthint3 = /** @type {((inputs?: Ticketsfieldstudenthint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldstudenthint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldstudenthint3(inputs)
	return de_ticketsfieldstudenthint3(inputs)
});
export { ticketsfieldstudenthint3 as "ticketsFieldStudentHint" }